<template>
	<div class="row rigid plan-cards relative">
		<aside class="overlay updating">
			<i class="fa fa-spinner fa-spin"></i>
		</aside>
		<div v-for="(plan, index) in planList" :key="index" class="plan-card" :class="{single:items === 1}">
			<header class="row separated">
				<h1 class="plan-title rigid placeholder"></h1>
			</header>
			<ul class="plan-features placeholder">
				<li></li>
				<li></li>
				<li></li>
			</ul>
			<div class="column separated-extra bottom">
				<div class="button disabled">
					<div class="placeholder"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>


export default {
	name: 'PlanCardPlaceholder',
	data(){
		return {
			planList: []
		};
	},
	props: {
		desc: Boolean,
		items: Number
	},
	created() {
		const rows = this.items || 1;
		for (let i = 0; i < rows; i++) {
			this.planList.push(i);
		}
	}
};

</script>

<style scoped>
.overlay {
	width: 1.5em;
	height: 1.5em;
	line-height: 1.5em;
}

.plan-card > header > h1 {
	margin-top: 0;
}
.plan-card > header {
	margin-bottom: 1.5em;
}
.plan-features li {
    line-height: 1.4rem;
    margin-bottom: .5rem;
}

.single .plan-features {
	width: 200px;
}

.single .button {
	display: none;
}
h1.placeholder {
	background-color: #ddd;
	width: 50%;
	height: 1em;
}
.dark h1.placeholder {
	background: #666;
}

.single h1.placeholder {
	width: 200px;
}

.plan-features.placeholder li {
	background-color: #f2f2f2;
	width: 100%;
	height: 1em;
}
.dark .plan-features.placeholder li {
	background-color: #333;
	width: 100%;
	height: 1em;
}
.button .placeholder {
	height: 1rem;
	line-height: 1.4rem;
}
</style>



// WEBPACK FOOTER //
// ./src/components/PlanCardPlaceholder.vue